import parse from "html-react-parser";

export default function DataRow({ label, data, icon, rightAligned }) {
  return (
    <div className="flex">
      <div className="w-1/3 shrink-0">
        <p className="text-sm lg:text-base text-olaf-green-500">
          <strong>{label}</strong>
        </p>
      </div>
      <div className="pl-4 w-2/3 shrink-0 flex items-center">
        {icon && <img src={icon} className="mr-2" alt="" />}
        <div className={rightAligned ? "ml-auto text-right" : ""}>
          {data ? (
            <p className="text-sm lg:text-base">{data}</p>
          ) : (
            <p className="text-sm lg:text-base">-</p>
          )}
        </div>
      </div>
    </div>
  );
}
